export type AutomationVersionHistoryTableFilters = {
  status?: string[];
  deployedAtStartTime?: string;
  deployedAtEndTime?: string;
  deployedByName?: string[];
};

export interface AutomationVersionHistoryFilterOptions {
  status?: string[];
  deployedAtStartTime?: string;
  deployedAtEndTime?: string;
  deployedByName?: string[];
}

export interface AutomationVersionHistoryData extends AutomationStructureNew {
  deployedAt?: string;
  deployedById: string;
  deployedByName: string;
  isLive?: boolean;
}

export interface DataTableRow {
  isRowActive: boolean;
  id: string;
  versionName: JSX.Element;
  deployedByName: string | JSX.Element;
  deployedAt: string;
  status: string;
}

export enum ActiveStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export const SF_PLATFORM_DEPLOYED_BY_NAME = 'Salesforce Platform';
